import { render } from "./ProjectAssetsComponent.vue?vue&type=template&id=4c4fa44f&scoped=true"
import script from "./ProjectAssetsComponent.vue?vue&type=script&lang=js"
export * from "./ProjectAssetsComponent.vue?vue&type=script&lang=js"

import "./ProjectAssetsComponent.vue?vue&type=style&index=0&id=4c4fa44f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4fa44f"]])

export default __exports__